import React, { useEffect, useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import Newsletter from "./structured-text/blocks/newsletter"
import { Close } from "./icons"
import IMG3 from "../assets/images/img-03.jpg"

const HASH = "#newsletter"

const NewsletterPopup = ({ autoOpen = false, location }) => {

  const { subscribeForm } = useStaticQuery(graphql`
    query NewsletterPopupQuery {
      subscribeForm: datoCmsForm(title: { eq: "Newsletter" }) {
        ...FormProps
      }
    }
  `)

  const [visible, setVisible] = useState(false)
  const [active, setActive] = useState(false)

  // A direct link to `#newsletter` always opens the popup, even if the visitor
  // has dismissed it before. Gatsby navigates with pushState, which doesn't
  // fire `hashchange`, so watch the router location as well as the event.
  useEffect(() => {
    const openFromHash = () => {
      if (window.location.hash !== HASH) return
      setVisible(true)
    }

    openFromHash()
    window.addEventListener("hashchange", openFromHash)
    return () => window.removeEventListener("hashchange", openFromHash)
  }, [location?.hash, location?.key])

  useEffect(() => {
    // The timed popup only runs where it's enabled (the homepage); everywhere
    // else the popup is reachable through the `#newsletter` link alone.
    if (!autoOpen) return
    if (window.location.hash === HASH) return
    if (window.localStorage.getItem("newsletter-popup-closed")) return

    const timer = setTimeout(() => setVisible(true), 2000)
    return () => clearTimeout(timer)
  }, [autoOpen])

  useEffect(() => {
    if (!visible) return
    const raf = requestAnimationFrame(() => setActive(true))
    return () => cancelAnimationFrame(raf)
  }, [visible])

  const closePopup = () => {
    window.localStorage.setItem("newsletter-popup-closed", "true")
    // Drop the hash so the link can be used again without a page reload.
    if (window.location.hash === HASH) {
      window.history.replaceState(null, "", window.location.pathname + window.location.search)
    }
    setActive(false)
    setTimeout(() => setVisible(false), 600)
  }

  const handleSubmitSuccess = () => {
    // Leave the confirmation message on screen long enough to read before
    // closing the popup.
    setTimeout(closePopup, 4000)
  }

  if (!visible || !subscribeForm) return null

  return (
    <div className={`newsletter-popup${active ? " newsletter-popup--active" : ""}`}>
      <button type="button" className="newsletter-popup__overlay" aria-label="Close newsletter popup" onClick={closePopup} />
      <div className="newsletter-popup__wrapper">
        <button type="button" className="newsletter-popup__close" aria-label="Close newsletter popup" onClick={closePopup}>
          <Close />
        </button>
        <Newsletter
          form={subscribeForm}
          image={IMG3}
          title="Subscribe to our Newsletter"
          description="We’d love to keep in touch. Join the FSC community and you’ll be the first to hear about new initiatives, projects and job openings."
          onSubmitSuccess={handleSubmitSuccess}
        />
      </div>
    </div>
  )
}

export default NewsletterPopup
